/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NotifyYes/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NotifyYes({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NotifyYes",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NotifyYes.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZhabuE': alignSelf,'--mt-2-ZhabuE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZhabuE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZhabuE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZhabuE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZhabuE': opacity,'--w-10-ZhabuE': typeof width === 'number' ? `${width}px` : width,'--h-11-ZhabuE': typeof height === 'number' ? `${height}px` : height,'--f-12-ZhabuE': fill,'--a-7-ZhabuE': isAnimated ? animation : "none",'--sd-8-ZhabuE': isAnimated ? strokeDashoffset : 0,'--sd-9-ZhabuE': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2NotifyYes.SvgPath"
  data-view-path={viewPath}
 clipRule="evenodd"
 d="M13.814 1.244a.75.75 0 10-1.128-.988L9.713 3.653 8.78 2.72a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.094-.036l3.5-4zM6 1.5c.369 0 .733.042 1.086.123a2 2 0 00-.25 3.041l1.5 1.5a2 2 0 002.236.41v3c0 .235.1.466.289.643.219.204.391.283.639.283a.5.5 0 010 1H.5a.5.5 0 010-1c.248 0 .42-.079.64-.283a.878.878 0 00.288-.642V5.8c0-1.152.49-2.25 1.351-3.053A4.725 4.725 0 016 1.5zM4.25 13.25A.75.75 0 015 12.5h2A.75.75 0 017 14H5a.75.75 0 01-.75-.75z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}